import { Button, CircularProgress } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { clinicId } from "../../../constants";
import { useMutation } from "react-query";
import { SaveReferalLetter } from "./services";
import usePrint from "../../../hooks/usePrint";
import { useContext } from "react";
import { EmrContext } from "../../index";
import usePopup from "@hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";

function ReferralLetterForm() {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { user } = useAuthentication();
  const { printPdf, loading } = usePrint();
  const { patientData } = useContext(EmrContext);
  const { control, handleSubmit, reset } = useForm();
  const { mutate: getreferalLetter, isLoading } = useMutation(
    SaveReferalLetter,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          printPdf(result.response);
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong",
          variant: "error",
          open: true,
          duration: 3000,
        });
      },
    },
  );

  const onSubmit = (data: any) => {
    const body = {
      clinicId: clinicId,
      compliant: data.compliant,
      department: data.department,
      examination: data.examination,
      hospital: data.hospital,
      id: encounterId,
      investigation: data.investigation,
      status: data.status,
      deptId: Number(patientData?.encounter?.departmentId),
      clinicianId: Number(user?.clinicianID),
    };
    getreferalLetter(body);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-3 gap-3">
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Hospital" }}
        name="hospital"
        rules={{ required: "hospital required" }}
      />

      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Department" }}
        name="department"
        rules={{ required: "department required" }}
      />
      <CustomFormField
        control={control}
        element="autocomplete"
        options={["Emergenecy", "Elective"]}
        fieldProps={{ label: "Status" }}
        name="status"
        rules={{ required: "status required" }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Compliant" }}
        name="compliant"
        rules={{ required: false }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Examination" }}
        name="examination"
        rules={{ required: "examination required" }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Investigation" }}
        name="investigation"
        rules={{ required: "investigation required" }}
      />

      <div className="flex gap-x-2  items-center">
        <Button
          type="submit"
          color="success"
          disabled={isLoading || loading}
          endIcon={(isLoading || loading) && <CircularProgress size={20} />}
        >
          submit
        </Button>
        <Button color="error" onClick={reset}>
          reset
        </Button>
      </div>
    </form>
  );
}

export default ReferralLetterForm;
